import { observer } from 'mobx-react';
import React from 'react';
import { localeStore } from '~/mobx/localesStore';
import Input from '~/view/components/Controls/Input/Input';
import T360MenuSet from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360MenuSet/T360MenuSet';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from '~/view/components/Text/Text';
import { TBooleanInNumber } from '~/types/main';
import Button from '~/view/components/Controls/ButtonComponent/Button';

interface IProps {
  settingName: string;
  integrationId: number;
  settingValue?: string | number | null;
  onChange: (settingName: string, value: string | number) => void;
  disabled?: boolean;
}

const T360SettingFields: React.FC<IProps> = observer((props: IProps) => {
  switch (props.settingName) {
    case 'menu_group':
      return (
        <T360MenuSet
          integrationId={props.integrationId}
          disabled={props.disabled}
          key={`${props.integrationId}-${props.settingName}`}
          wrapperClassName="t360-screen-settings-container__setting-wrapper"
        />
      );
    case 't360_auto_accept_orders':
      return (
        <div
          key={`${props.integrationId}-${props.settingName}`}
          className="d-flex flex-row align-items-center t360-screen-settings-container__setting-wrapper full-width"
        >
          <Switcher
            className="mr-4"
            status={(props.settingValue ?? 0) as TBooleanInNumber}
            onChange={(value) => props.onChange(props.settingName, value)}
            disabled={props.disabled}
          />
          <Text
            className="mr-3 foodics-authorized-form__checkbox-title"
            type={TEXT.CUSTOM}
            text="t360_auto_accept_orders"
            disabled={props.disabled}
          />
        </div>
      );
    default:
      return (
        <div className="d-flex flex-column t360-screen-settings-container__setting-wrapper" key={`${props.integrationId}-${props.settingName}`}>
          <h3 className="family-bold text-size-18 mb-2">{localeStore.t(props.settingName)}</h3>
          <Input
            className={`item-prices__input ${props.disabled ? 'disabled' : ''}`}
            value={props.settingValue ?? ' '}
            disabled={props.disabled}
            placeholder={`${localeStore.t('Enter')} ${localeStore.t(props.settingName)}`}
            onChange={(value) => props.onChange(props.settingName, value.target.value)}
          />
        </div>
      );
  }
});

export default T360SettingFields;
